import { render, staticRenderFns } from "./SetCreditQuotaDialog.vue?vue&type=template&id=1d4c587e&scoped=true"
import script from "./SetCreditQuotaDialog.vue?vue&type=script&lang=js"
export * from "./SetCreditQuotaDialog.vue?vue&type=script&lang=js"
import style0 from "./SetCreditQuotaDialog.vue?vue&type=style&index=0&id=1d4c587e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4c587e",
  null
  
)

export default component.exports